import type { TFunction } from "i18next"

// Canonical effort stops with English fallback labels (backend values are
// lowercase tokens). Lives outside the EffortSlider component file so
// component files export only components (react-refresh/only-export-components).
const EFFORT_LABELS: Record<string, string> = {
  none: "None",
  minimal: "Minimal",
  low: "Low",
  medium: "Medium",
  high: "High",
  xhigh: "xHigh",
  max: "Max",
}

/**
 * Human label for an effort stop. Pass `t` to localize via the
 * `reasoning_mode.effort_<stop>` keys — surfaces like the shortcut toast and
 * the slider labels are otherwise half-translated ("Resonemangsnivå: High").
 * Unknown stops (and calls without `t`) fall back to the raw token / English.
 */
export function effortLabel(effort: string, t?: TFunction): string {
  const fallback = EFFORT_LABELS[effort] ?? effort
  if (!t || !(effort in EFFORT_LABELS)) return fallback
  return t(`reasoning_mode.effort_${effort}`, { defaultValue: fallback })
}
